<template>
  <a-space direction="vertical" :style="{ width: '100%' }" :size="[0, 48]">
    <a-layout class="layout-outer">
      <AppSidebar />
      <a-layout class="layout-inner">
        <AppHeader />
        <a-layout-content class="layout-content">
            <router-view />
        </a-layout-content>
        <AppFooter />
      </a-layout>
    </a-layout>
  </a-space>
</template>


<script>
import AppSidebar from '../components/AppSidebar.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';
export default {
  name: 'AdminLayout',
  components: {
    AppSidebar,
    AppHeader,
    AppFooter
  },
  setup() {

  },
}
</script>
<style scoped>
.layout-outer {
  height: 100vh;
  overflow: hidden;
}

.layout-inner {
  overflow: hidden;
}

.layout-content {
  flex: 1;
  overflow-y: auto;
}
</style>
